export interface IBackoffStrategy {
    backoff(attemptNumber: number): number;
}

export class DecorrelatedBackoffStrategy implements IBackoffStrategy {
    private currentDelayInMs: number;

    constructor(private readonly baseDelayInMs: number,
        private readonly maxDelayInMs: number,
        private readonly random: () => number = Math.random) {

        this.currentDelayInMs = baseDelayInMs;
    }

    public backoff(attemptNumber: number): number {
        return this.currentDelayInMs = Math.min(this.maxDelayInMs, this.baseDelayInMs + (this.random() * ((this.currentDelayInMs * 3) - this.baseDelayInMs)));
    }
}


// WEBPACK FOOTER //
// ./src/util/domain/backoffStrategy.ts